import {DOM} from '../helpers/DOM.js'

export default class LightBox {
	#lightboxElement = null;
	#animating = false;

	constructor() {
		this.addEvents();
	}

	addEvents() {
		DOM.addEvent('click', '[data-lev-lightbox]', (event, object) => {
			if (this.#animating) return;

			this.create(object);
			this.show();
		});
		DOM.addEvent('click', '.levcharity_lightbox_wrapper .levcharity_lightbox_close', (event) => {
			if (this.#animating) return;

			this.hide(() => {
				this.remove();
			})
		});
	}

	create(element) {
		const tagName = element.tagName.toLowerCase();
		const src = element.dataset.levLightboxSrc;

		this.#lightboxElement = DOM.create('div', {
			className: 'levcharity_lightbox_wrapper',
			style: 'display: none; opacity: 0;'
		}, [
			DOM.create('div', {
				className: 'levcharity_lightbox'
			}, [
				DOM.create(tagName, {
					src,
					className: 'levcharity_lightbox_object'
				}),
				DOM.create('span', {
					className: 'levcharity_lightbox_close'
				}, "×")
			])
		])

		document.body.append(this.#lightboxElement)
	}

	remove() {
		this.#lightboxElement.remove();
		this.#lightboxElement = null;
	}

	async show(onComplete = () => {}) {
		if (!this.#lightboxElement || this.#animating) return;
		const { gsap } = await import(/* webpackChunkName: "gsap" */ 'gsap');
		this.#animating = true;
		gsap.to(this.#lightboxElement, {
			display: '',
			opacity: 1,
			duration: .4,
			onComplete: (...e) => {
				this.#animating = false;
				onComplete(...e)
			}
		})
	}

	async hide(onComplete = () => {}) {
		if (!this.#lightboxElement || this.#animating) return;
		const { gsap } = await import(/* webpackChunkName: "gsap" */ 'gsap');
		this.#animating = true;
		gsap.to(this.#lightboxElement, {
			display: 'none',
			opacity: 0,
			duration: .4,
			onComplete: (...e) => {
				this.#animating = false;
				onComplete(...e)
			}
		})
	}
}
